<template>
  <v-app>
    <v-main>
      <v-locale-provider :rtl="isRtl">
        <!-- <app-bar /> -->
        <router-view />
      </v-locale-provider>
    </v-main>
  </v-app>
</template>

<script>
import store from "@/store/index.js";
export default {
  name: "App",
  components: {
    // SvgIcon,
  },
  data: () => ({}),
  computed: {
    isRtl() {
      // Replace 'ar', 'he', etc., with your actual RTL language codes
      const rtlLanguages = ["ar", "he", "fa", "ur"];
      return rtlLanguages.includes(this.$i18n.locale);
    },
  },
  async mounted() {
    await store.dispatch("fetchPictures");
  },
};
</script>
<style>
@import "./assets/fonts.css";

body {
  /* font-family: tajawal; */
  font-family: ReadexPro;
  background-color: grey;
}

.swal2-container {
  z-index: 99999 !important;
}
</style>
